/** gets a list of counties to populate the dropdown menu on members_browse */

import Navigator from 'app';

/** list of counties to populate the dropdown on members_browse */
const CountyCollection = Backbone.Collection.extend({
  model: Backbone.Model.extend(),
  url: Navigator.config.api_base + 'counties/',
  comparator: 'cntyName'
});
const API = {
  getCounties: function () {
    var d = $.Deferred();
    if (!Navigator.counties || Navigator.counties.length === 0) {
      Navigator.counties = new CountyCollection();
      Navigator.counties.fetch({
        dataType: "json",
        success: function (data) {
          d.resolve(data);
        }
      });
      return d.promise();
    } else {
      return Navigator.counties;
    }
  }
};
Navigator.reqres.setHandler("counties", function () {
  return API.getCounties();
});
export { CountyCollection as default };